// extracted by mini-css-extract-plugin
export var grid = "_1r-0";
export var span1 = "_1r-2";
export var span10 = "_1r-b";
export var span10L = "_1r-z";
export var span10M = "_1r-n";
export var span10Xl = "_1r-1b";
export var span11 = "_1r-c";
export var span11L = "_1r-10";
export var span11M = "_1r-o";
export var span11Xl = "_1r-1c";
export var span12 = "_1r-d";
export var span12L = "_1r-11";
export var span12M = "_1r-p";
export var span12Xl = "_1r-1d";
export var span1L = "_1r-q";
export var span1M = "_1r-e";
export var span1Xl = "_1r-12";
export var span2 = "_1r-3";
export var span2L = "_1r-r";
export var span2M = "_1r-f";
export var span2Xl = "_1r-13";
export var span3 = "_1r-4";
export var span3L = "_1r-s";
export var span3M = "_1r-g";
export var span3Xl = "_1r-14";
export var span4 = "_1r-5";
export var span4L = "_1r-t";
export var span4M = "_1r-h";
export var span4Xl = "_1r-15";
export var span5 = "_1r-6";
export var span5L = "_1r-u";
export var span5M = "_1r-i";
export var span5Xl = "_1r-16";
export var span6 = "_1r-7";
export var span6L = "_1r-v";
export var span6M = "_1r-j";
export var span6Xl = "_1r-17";
export var span7 = "_1r-8";
export var span7L = "_1r-w";
export var span7M = "_1r-k";
export var span7Xl = "_1r-18";
export var span8 = "_1r-9";
export var span8L = "_1r-x";
export var span8M = "_1r-l";
export var span8Xl = "_1r-19";
export var span9 = "_1r-a";
export var span9L = "_1r-y";
export var span9M = "_1r-m";
export var span9Xl = "_1r-1a";
export var stretch = "_1r-1";